const testimonials = [
  {
    name: "Amanda L.",
    location: "Tallahassee, FL",
    rating: 5,
    text: "I'm an FSU graduate student heading to Spain for a research conference in 10 days and realized my passport had expired. Fast Passport Center got my renewal back in 6 days. Their team walked me through shipping from the UPS Store on Tennessee Street and kept me updated every step of the way.",
    service: "Passport Renewal",
  },
  {
    name: "Robert H.",
    location: "Killearn, Tallahassee",
    rating: 5,
    text: "My son needed a passport for a FAMU study abroad program to Ghana. We live in Killearn and had no idea where to start. FPC handled everything — guided us to the Leon County Clerk for the acceptance step, then took over from there. His passport arrived in 8 days. Unbelievable service.",
    service: "Child Passport",
  },
  {
    name: "Michelle T.",
    location: "Quincy, FL",
    rating: 5,
    text: "I work for a state agency in Tallahassee and had an emergency trade mission to Brazil with less than two weeks notice. My passport was lost during a move from Quincy to Tallahassee. FPC walked me through the DS-64 process, helped me find the right clerk, and got my replacement in 7 days. Truly a lifesaver.",
    service: "Lost Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function TallahasseeTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Tallahassee Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Tallahassee, Quincy, and the Big Bend region who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}